export default class ClearButton {
    constructor(element, parent) {
        this.parent = parent;
        this.element = element;
    }

    init() {
        this.registerEffects();
    }

    registerEffects() {
        this.parent.block.addEventListener('gg-filter-changed', () => {
            if (this.parent.isActive) {
                this.element.classList.remove('active');
            } else {
                this.element.classList.add('active');
            }
        });

        this.element.addEventListener('click', (event) => {
            this.parent.filters.forEach((item) => item.clear());

            if (this.parent.hasActiveTag) {
                this.parent.activeFiltersTag.querySelector('.gravity-block-filters__active-tag-container').innerHTML =
                    '';
            }

            this.clearFilterArgs();

            this.parent.sendFiltersChange(event.target);
        });
    }

    clearFilterArgs() {
        this.parent.filterArgs = {
            content_type: [],
            taxonomy: {},
            order_by: '',
            order: '',
            date_range_type: '',
        };
    }
}
